import { render } from "./AddApModal.vue?vue&type=template&id=50972d9d&scoped=true"
import script from "./AddApModal.vue?vue&type=script&lang=js"
export * from "./AddApModal.vue?vue&type=script&lang=js"

import "./AddApModal.vue?vue&type=style&index=0&id=50972d9d&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-50972d9d"]])

export default __exports__